const gql = {
  query: `mutation addPhoneNumber($input: PhoneInputList!) {
        addPhoneNumber(input: $input)
    }`,
  variables: {
    input: {
      phoneInputList: null,
    },
  },
  meta: {
    label: "Add Phone Number",
  },
};

export default gql;
